// extracted by mini-css-extract-plugin
export default {"content":"style_content__MW8Rx","search":"style_search__nC1Uc","tag":"style_tag__6Mwdq"};